export const reduxKey = '@@UnreadChats';

//# sourceMappingURL=constants.js.map